import { Trans, useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { Form } from '@anytag/shared-atoms';
import { formatIntNumber } from '@anytag/shared-utils';
import { SelectOption, SortOption } from '@anytag/shared-types';
import { LIMIT_100, LIMIT_50, LIMIT } from '@anytag/shared-constants';
import { SocialAccountInfluencerListSortField } from '@anytag/graphql';
import { SelectorField, SingleSelectorFieldProps } from '@anytag/shared-molecules';
import { TikTokCampaignInfluencersSortFormKeys, TikTokCampaignInfluencersSortFormValues } from './types';

export interface TemplateProps {
  totalRecords?: number;
  onSubmit?: () => void;
  sortOptions: SortOption<SocialAccountInfluencerListSortField>[];
}

export const Template = ({ onSubmit, sortOptions, totalRecords = 0 }: TemplateProps) => {
  const { t } = useTranslation();
  const { setValue } = useFormContext<TikTokCampaignInfluencersSortFormValues>();

  const limitOptions: SelectOption<string>[] = [
    { value: LIMIT.toString(), label: t<string>('View_limit', { count: LIMIT }) },
    { value: LIMIT_50.toString(), label: t<string>('View_limit', { count: LIMIT_50 }) },
    { value: LIMIT_100.toString(), label: t<string>('View_limit', { count: LIMIT_100 }) }
  ];

  const handleSortChange: SingleSelectorFieldProps<
    TikTokCampaignInfluencersSortFormKeys,
    SortOption<SocialAccountInfluencerListSortField>
  >['onChange'] = (field, value, options) => {
    const selectedOption = options.find((option) => option.value === value);
    setValue(field, value);
    setValue('field', selectedOption?.field || null);
    setValue('order', selectedOption?.order || null);
  };

  return (
    <Form.Fields className="items-center">
      <Form.Field className="flex-none">
        <p css={{ fontSize: '14px', fontWeight: 600 }}>
          <Trans i18nKey="Accounts found" values={{ count: formatIntNumber(totalRecords) }} />
        </p>
      </Form.Field>

      <SelectorField<TikTokCampaignInfluencersSortFormKeys, SortOption<SocialAccountInfluencerListSortField>>
        name="sort"
        onSubmit={onSubmit}
        options={sortOptions}
        onChange={handleSortChange}
        className="ml-auto max-w-max min-w-30"
        placeholder={t<string>('Selector.Sort')}
      />

      <SelectorField<TikTokCampaignInfluencersSortFormKeys>
        name="limit"
        clearable={false}
        onSubmit={onSubmit}
        options={limitOptions}
        className="max-w-30"
      />
    </Form.Fields>
  );
};
